import React 			from 'react'
import classnames		from 'classnames'
import ReactPlayer 		from 'react-player'

const formatVideoString = (str) => {
	if(!str || str.length <= 0){ return null }
	let _s = str.trim()
	if(_s.substring(str.length - 1) === '#'){
		_s = _s.substring(0, str.length - 1)
	}
	return _s
}

export default (props) => {
	const {
		video
	} = props

	const _video = formatVideoString(video)

	return _video ? <div className="videoEl">
		<ReactPlayer
			url={ _video }
			width="100%"
          	height="100%"
			/>
	</div> : null
}